import React, {Component} from 'react';
import modalStyle from "../../../assets/jss/material-dashboard-pro-react/modalStyle";
import Dialog from "@material-ui/core/es/Dialog/Dialog";
import withStyles from "@material-ui/core/es/styles/withStyles";
import * as classnames from "classnames";
import Grow from "@material-ui/core/es/Grow/Grow";
import DialogTitle from "@material-ui/core/es/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/es/DialogContent/DialogContent";


class Modal extends Component {

    render() {
        const {classes, onClose, open, content, title, medium, small, ...rest} = this.props;
        return (
            <Dialog
                fullWidth
                disableEnforceFocus
                classes={{
                    root: classes.modalRoot,
                    paper: medium ? classnames({[classes.modal]: true, [classes.medium]: !small}) : classnames({[classes.modal]: true, [classes.big]: !small})
                }}
                open={!!open}
                // TransitionComponent={(props) => <Grow unmountOnExit mountOnEnter {...props}/>}
                TransitionComponent={Grow}
                onClose={onClose}
                {...rest}>
                <DialogTitle className={classes.modalTitle}>
                    {title}
                </DialogTitle>
                <DialogContent
                    id="modal-slide-description"
                    className={classes.modalBody}>
                    {content}
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(modalStyle)(Modal)



// WEBPACK FOOTER //
// ./src/components/material-pro/Modal/Modal.js